import { featureGroup } from "leaflet";
import Icons from "../../../utils/icons";

// Define the Route interface for consistency and type safety
interface Route {
  name: string;
  slug: string;
  groupName?: string;
  moduleName?: string;
  byPass: boolean;
  feature?: string;
  icon?: any; // Allows different icon types
  children?: Route[];
}

// Define the DrawerConfig structure
interface DrawerConfigType {
  Common: Route[];
}

// Define the routes under Common
const Common: Route[] = [
  {
    name: "Dashboard",
    icon: Icons.Link,
    byPass: true,
    slug: "/",
    feature: "Dashboard",
  },
  {
    name: "My ToDo",
    icon: Icons.List,
    byPass: true,
    slug: "/mytodos",
    feature: "My ToDo",
  },
  {
    name: "Master",
    icon: Icons.Home,
    byPass: true,
    slug: "master",
    children: [
      {
        name: "User Management",
        slug: "/user-registration",
        byPass: true,
        feature: "Admin \\ User Registration",
      },
      {
        name: "Picklist",
        slug: "/picklist",
        byPass: true,
        feature: "Admin \\ Picklist Management",
      },
      {
        name: "Teams",
        slug: "/add-Teams",
        byPass: true,
        feature: "Admin \\ Team Management",
      },
      {
        name: "Parties",
        slug: "/parties",
        byPass: true,
        feature: "Admin \\ Stakeholder Management",
      },
      {
        name: "Location",
        slug: "/location",
        byPass: true,
        feature: "Admin \\ Location",
      },
      {
        name: "Billing Configuration",
        slug: "/billing-configuration",
        byPass: true,
        feature: "Admin \\ Billing Configuration",
      },
    ],
  },
  {
    name: "Case Management",
    icon: Icons.Review,
    byPass: true,
    slug: "case_management",
    children: [
      {
        name: "Search Case",
        slug: "/search-case",
        byPass: true,
        feature: "Search Case",
      },
      {
        name: "Create Case",
        slug: "/create-case",
        byPass: true,
        feature: "Create Case",
      },
    ],
  },
  {
    name: "QME Profile",
    icon: Icons.Badge,
    byPass: true,
    slug: "/profile",
    feature: "QME Profile",
  },
  {
    name: "Share Records",
    icon: Icons.Share,
    byPass: true,
    slug: "/shareRecords",
    feature: "Share Records",
  },
  {
    name: "Appointments",
    icon: Icons.Safety_Check,
    byPass: true,
    slug: "/appointment",
    feature: "Appointment",
  },
  {
    name: "Configuration",
    icon: Icons.List_Alt_Check,
    byPass: true,
    slug: "configuration",
    children: [
      {
        name: "Notification Preference",
        slug: "/notification-preference",
        byPass: true,
        feature: "Admin \\ Configuration",
      },
    ],
  },
  {
    name: "Invoice",
    icon: Icons.Receipt,
    byPass: true,
    slug: "invoice",
    children: [
      {
        name: "Manage Invoice",
        slug: "/manage-invoice",
        byPass: true,
        feature: "Invoice \\ Manage Invoice",
      },
      {
        name: "Invoice Reports",
        slug: "/invoice-reports",
        byPass: true,
        feature: "Invoice \\ Invoice Reports",
      },
    ],
  },
];

const DrawerConfig: DrawerConfigType = {
  Common,
};

export default DrawerConfig;
